'use client';

import {
  type EmoticonType,
  useEmoticonFilterQuery,
} from '@module/queries/guide/useEmoticonFilterQuery/useEmoticonFilterQuery';
import { type EmoticonFilterState, useEmoticonFilterStore } from '@module/stores/useEmoticonFilterStore';
import formatNumberWithComma from '@module/utils/formatNumberWithComma';

const getSearchValueString = (
  searchType: EmoticonFilterState['searchType'],
  bjId: string,
  minHeart: string,
  maxHeart: string,
) => {
  if (searchType === 'bj') return bjId;
  if (searchType === 'heart') {
    const minHeartValue = Number(minHeart) === 0 ? '' : formatNumberWithComma(minHeart);
    const maxHeartValue = Number(maxHeart) === 0 ? '' : formatNumberWithComma(maxHeart);
    return `${minHeartValue} ~ ${maxHeartValue}`;
  }
  return '';
};

interface EmoticonSearchResultSummaryProps {
  type: EmoticonType;
  filterType: 'all' | 'crew';
}

const SignatureEmoticonSearchResultSummary = ({ type, filterType }: EmoticonSearchResultSummaryProps) => {
  const searchType = useEmoticonFilterStore((state) => state.searchType);
  const bjId = useEmoticonFilterStore((state) => state.bjId);
  const minHeart = useEmoticonFilterStore((state) => state.minHeart);
  const maxHeart = useEmoticonFilterStore((state) => state.maxHeart);
  const { queryResult } = useEmoticonFilterQuery({
    isInfinite: false,
    limit: 15,
    type,
    fixedFilterType: filterType,
  });

  if (!queryResult.data) return null;
  if (bjId === '' && searchType === 'bj') return null;
  if (minHeart === '' && maxHeart === '' && searchType === 'heart') return null;
  return (
    <p className='mt-4 flex'>
      <span className='font-bold text-baseFg'>{`'${getSearchValueString(searchType, bjId, minHeart, maxHeart)}' 검색결과`}</span>
      <span className='ml-1 text-[#ef312a]'>{`${queryResult.data.page.total}`}</span>
      <span className='text-colorFg18'>개</span>
    </p>
  );
};

export default SignatureEmoticonSearchResultSummary;
